export const LICENSE_TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'id', label: 'Id', alignRight: false },
  { id: 'validity', label: 'Validade', alignRight: false },
  { id: 'demo', label: 'Demo', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];
